import React from "react"

import { notificationTypes } from "../../../../config/application-definitions"
import NotificationEntityPreview from "../view/NotificationEntityPreview"

const NotificationEditLinkDetails = ({
    link,
    type,
    entityId,
    onEventChange,
}) => {
    const linkFieldName =
        (notificationTypes[type] && notificationTypes[type].linkType) || "link"
    const useEntityLink = linkFieldName === "entity_id"
    const entityLabel =
        (notificationTypes[type] && notificationTypes[type].label) || "Item"
    const linkLabel = useEntityLink ? `Related ${entityLabel}` : "Link"
    const linkPlaceholder = useEntityLink ? `${entityLabel} ID` : "Link"
    const linkValue = useEntityLink ? entityId : link
    return (
        <div className="widget">
            <div className="widget-content">
                <h3 className="first-heading">
                    <i className="icon icon-insights" />
                    Notification type
                </h3>
                <select
                    className="form-control"
                    name="type"
                    value={type}
                    onChange={onEventChange}
                >
                    {Object.keys(notificationTypes).map((notificationKey) => (
                        <option value={notificationKey} key={notificationKey}>
                            {notificationTypes[notificationKey].label}
                        </option>
                    ))}
                </select>
                <h3>
                    <i className="icon icon-article" />
                    {linkLabel}
                </h3>
                <input
                    type="text"
                    name={linkFieldName}
                    className="form-control"
                    placeholder={linkPlaceholder}
                    value={linkValue}
                    onChange={onEventChange}
                    style={{ marginBottom: "5px" }}
                />
                {useEntityLink && (
                    <NotificationEntityPreview
                        type={type}
                        entityId={entityId}
                        isEditing={true}
                    />
                )}
            </div>
        </div>
    )
}

export default NotificationEditLinkDetails
